module.exports = __webpack_public_path__ + "static/media/process2.ecbafe31.jpeg";